import React from 'react';
import Button from '@/components/ui/Button';
import {Tooltip} from '@/components/tooltips';

import useOptimizedConfig from '@/hooks/useOptimizedConfig';
import {isModuleEnabled} from '@/utils/modules';
import i18n from 'i18n';
interface ChartExplainerIconButtonProps {
    chartId: number;
    className?: string;
    chartTitle?: string;
    chartType?: string;
    onToggleExplanation?: () => void;
}

const ChartExplainerIconButton: React.FC<ChartExplainerIconButtonProps> = ({
    chartId,
    className = '',
    chartTitle,
    chartType,
    onToggleExplanation
}) => {
    const {userData} = useOptimizedConfig();
    const moduleEnabled = isModuleEnabled(userData, 'addon-explain-chart');

    const handleExplainClick = () => {
        if (!moduleEnabled) {
            return;
        }
        if (onToggleExplanation) {
            onToggleExplanation();
        }
    };

    if (moduleEnabled) {
        return (
            <Tooltip content={i18n.t("jt_explain_chart_tooltip.text")} placement="top">
                <Button
                    variant="outline-info"
                    size="sm"
                    icon="mdi-brain"
                    className={className}
                    onClick={handleExplainClick}
                    data-cy="chart-explainer-icon-button-outlineinfo-btn"
                />
            </Tooltip>
        );
    }

    return (
        <Tooltip content={i18n.t("jt_explain_chart_not_enabled_tooltip.text")} placement="top">
            <div style={{cursor: 'not-allowed', display: 'flex', alignItems: 'center'}}>
                <Button
                    variant="secondary"
                    size="sm"
                    disabled
                    className={className}
                    data-cy="chart-explainer-icon-button-outlineinfo-btn"
                >
                    ?
                </Button>
            </div>
        </Tooltip>
    );
};

export default ChartExplainerIconButton;